module.exports = __webpack_public_path__ + "static/09-c178b69eca9c944145b734f830a2fd98.jpg";